import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Spinner,
} from "reactstrap";
import { getDashboardBestSelling } from "../../api/ecommerce";
import { resolveProductImageSrc } from "../../helpers/productImageUrl";
import { getUserRole } from "../../helpers/role_helper";
import { getLoggedinUser } from "../../api";

const BestSellingProducts = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const userProfile = getLoggedinUser();
  const userRole = getUserRole(userProfile);
  const userId = userProfile?.id || userProfile?.uid || userProfile?._id;

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    const params = { limit: 5 };
    if (userRole === "seller" && userId) {
      params.seller_id = userId;
    }

    getDashboardBestSelling(params)
      .then((data) => {
        if (cancelled) return;
        const list = Array.isArray(data) ? data : data?.data || [];
        setRows(list);
      })
      .catch(() => {
        if (!cancelled) setRows([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <React.Fragment>
      <Col xl={6}>
        <Card>
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">Best Selling Products</h4>
            <div className="flex-shrink-0">
              <UncontrolledDropdown className="card-header-dropdown">
                <DropdownToggle tag="a" className="text-reset" role="button">
                  <span className="fw-semibold text-uppercase fs-12">Sort by: </span>
                  <span className="text-muted">
                    Units sold
                    <i className="mdi mdi-chevron-down ms-1"></i>
                  </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <DropdownItem header>Based on order line items</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </CardHeader>

          <CardBody>
            {loading ? (
              <div className="text-center py-5">
                <Spinner color="primary" /> Loading...
              </div>
            ) : (
              <div className="table-responsive table-card">
                <table className="table table-hover table-centered align-middle table-nowrap mb-0">
                  <tbody>
                    {(rows || []).length === 0 ? (
                      <tr>
                        <td colSpan={5} className="text-muted text-center py-4">
                          No sales data yet. Orders with products will appear here.
                        </td>
                      </tr>
                    ) : (
                      rows.map((item) => {
                        const imgUrl = resolveProductImageSrc(item.thumbnail);
                        return (
                          <tr key={item.id}>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="avatar-sm bg-light rounded p-1 me-2">
                                  <img
                                    src={
                                      imgUrl ||
                                      "https://via.placeholder.com/100?text=No+Image"
                                    }
                                    alt=""
                                    className="img-fluid d-block"
                                    style={{ maxHeight: 48, objectFit: "cover" }}
                                    onError={(e) => {
                                      e.target.src = "https://via.placeholder.com/100?text=No+Image";
                                    }}
                                  />
                                </div>
                                <div>
                                  <h5 className="fs-14 my-1">
                                    <Link
                                      to={`/apps-ecommerce-product-details/${item.id}`}
                                      className="text-reset"
                                    >
                                      {item.label}
                                    </Link>
                                  </h5>
                                  <span className="text-muted">Units sold (all orders)</span>
                                </div>
                              </div>
                            </td>
                            <td>
                              <h5 className="fs-14 my-1 fw-normal">
                                £{Number(item.price || 0).toFixed(2)}
                              </h5>
                              <span className="text-muted">Price</span>
                            </td>
                            <td>
                              <h5 className="fs-14 my-1 fw-normal">{item.orders}</h5>
                              <span className="text-muted">Qty sold</span>
                            </td>
                            <td>
                              <h5 className="fs-14 my-1 fw-normal">
                                {item.stock > 0 ? (
                                  item.stock
                                ) : (
                                  <span className="badge bg-danger-subtle text-danger">Out of stock</span>
                                )}
                              </h5>
                              <span className="text-muted">Stock</span>
                            </td>
                            <td>
                              <h5 className="fs-14 my-1 fw-normal">£{Number(item.amount || 0).toFixed(2)}</h5>
                              <span className="text-muted">Revenue</span>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            )}

            <div className="align-items-center mt-4 pt-2 justify-content-between row text-center text-sm-start">
              <div className="col-sm">
                <div className="text-muted">
                  Showing <span className="fw-semibold">{rows.length}</span> top products by units sold
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default BestSellingProducts;
